import React from "react";

import ReactLoading from "react-loading";

const Loading = () => {
  return <ReactLoading type="bars" color="#fff" height={"100px"} width={"100px"} />;
};

export default Loading;
